import { ForSale } from '../constants/channels';
import { Selling } from '../constants/customerChannels';
import type { AllChannelObjects } from '../tsTypes';

export const queryStringFromChannelObject = (channelObject: AllChannelObjects | undefined) => {
  const isDefaultChannel =
    !channelObject ||
    (channelObject.id === ForSale.id && channelObject.url === ForSale.url) ||
    (channelObject.id === Selling.id && channelObject.url === Selling.url);

  return !isDefaultChannel ? channelObject.url : undefined;
};

const homepageUrlGenerator = (
  channelObject: AllChannelObjects | undefined,
  currentPath: string = '/',
) => {
  const newChannelString = queryStringFromChannelObject(channelObject);
  const channelString = newChannelString ? `?channel=${newChannelString}` : '';

  const url = new URL(`${currentPath}${channelString}`, 'https://not-important.com');
  return `${url.pathname}${url.search}`;
};

export default homepageUrlGenerator;
